// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btn-my-dashboard[data-v-2ada2729] .v-icon{margin-top:-3px!important}.toggle-tooltip[data-v-2ada2729]{position:absolute;top:-125px;right:40px;z-index:2}@media(max-width:1279px){.toggle-tooltip[data-v-2ada2729]{right:0;left:10px}}@media(max-width:767px){.toggle-tooltip[data-v-2ada2729]{left:-160px;right:0}}@media(max-width:399px){.toggle-tooltip[data-v-2ada2729]{left:-88px;right:0}}", ""]);
// Exports
module.exports = exports;
